import { SagaIterator } from 'redux-saga';
import { AxiosResponse, AxiosError } from 'axios';
import { put, call, takeLatest, StrictEffect, select } from 'redux-saga/effects';
import { apiInstance } from 'src/services/interceptor';
import { paymentInfoAction, paymentInfoSucceededAction, paymentInfoFailedAction } from './index';
import { IPaymentData } from './types';

function* paymentInfoWorker(): SagaIterator {
  try {
    const { tenantId } = yield select((state) => state.user.data);
    const response: AxiosResponse = yield call(apiInstance, `tenant/${tenantId}`);
    const reporttoolResponse: AxiosResponse = yield call(apiInstance, `reporttool/subscription/data/${tenantId}`);
    const data: IPaymentData = Object.assign({}, response.data, {
      subscriptionScannedPages: reporttoolResponse?.data?.subscriptionScannedPages,
    });
    yield put(paymentInfoSucceededAction({ data }));
  } catch (error) {
    if (error instanceof AxiosError) {
      console.log(error.message);
      yield put(paymentInfoFailedAction(error.message));
    }
  }
}

function* paymentRootSaga(): Generator<StrictEffect, void> {
  yield takeLatest(paymentInfoAction.type, paymentInfoWorker);
}

export { paymentRootSaga };
